import React from 'react';
import { Link } from 'react-router-dom';
import Headline from '../../partials/Headline';
import Text from '../../partials/Text';
import routes from '../../routes.json';
import GuidePost from '../../components/GuidePost';

import aroma_red from '../../assets/images/icons/aroma_red.svg';
import massage_white from '../../assets/images/icons/massage_white.svg';
import wellness_blue from '../../assets/images/icons/wellness_blue.svg';

const posts = [
  {
    backgroundColor: '#F3E4DF',
    textColor: '#651E38',
    route: routes.AROMATHERAPY,
    title: 'Aromaterapie',
    imageUrl: aroma_red,
    imageAlt: 'aromatherapy',
    btnText: 'Více',
  },
  {
    backgroundColor: '#AEC2B9',
    textColor: '#FFFFFF',
    route: routes.MASSAGE,
    title: 'Masáže',
    imageUrl: massage_white,
    imageAlt: 'masáž',
    btnText: 'Více',
  },
  {
    backgroundColor: '#DBE2E6',
    textColor: '#104366',
    route: routes.WELLNESS,
    title: 'Wellness',
    imageUrl: wellness_blue,
    imageAlt: 'wellness',
    btnText: 'Více',
  }
]

const WellnessPage = () => {
  return (
    <div className="page page-wellness">
      <div className="container container_narrow"> 
        <Headline h={1}>
          Wellness
        </Headline>
        <section className="page-section section-wellness">
          <div className="row">
            <div className="col">
              <Text className="text_subheadline">
                Rovnováha mezi vnitřním a vnějším světem
              </Text>
              <Text>
                Může se zdát, že je aromaterapie mladou disciplínou, objevenou začátkem 20. století panem Gattefosse a v současné době se stala moderní a velmi populární. Opak je ovšem pravdou. Odedávna lidské pokolení využívalo darů přírody a bylinářství mělo svou nezastupitelnou roli v životě člověka. Pokora a úcta k prostým bylinám byly nedílnou součástí rozsáhlých vědomostí většinou opatrovaných a předávaných z jednoho pokolení na druhé. Tzv. moderní fytoterapie se potom rodila nejen za klášterními zdmi, ale i „žila“ u prostých lidí spojených s přírodními cykly. Součástí bylinného repertoáru byly i siličnaté rostliny, které se hojně využívaly pro své blahodárné a léčivé účinky. 
              </Text>
              <Text className="text_subheadline">
                Co nám může aromaterapie nabídnout?
              </Text>
              <Text>
                Asi nejjednodušší, co lze z rozsáhlé nabídky vybrat je prevence virových onemocnění. Esenciální oleje /EO/ rozprášené ve vzduchu místnosti. Schopnost přinést úlevu při masáži ztuhlých svalů prostřednictvím směsi nosného oleje a zvolených EO.  Nebo vhodně připravená směs EO, která dokáže během několika minut inhalace zvládnout emoční vypětí a zklidnit zjitřenou mysl … to už je „vyšší dívčí“, kdy je třeba hlubších znalostí. Pokud klient spolupracuje i každý den a aplikuje si doma na míru připravenou směs, dokáže si aromaterapie poradit s obtížemi typu PMS nebo nespavost. Možnosti jsou opravdu velké. 
              </Text>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Link 
                to={routes.CONTACT}
                className="btn btn-primary"
              >
                Objednat se
              </Link>
            </div>
            <div className="col">
              <Link 
                to={routes.PRICES}
                className="btn btn-green"
              >
                Ukázat ceny
              </Link>
            </div>
          </div>
        </section>
      </div>
      <div className="container">
        <GuidePost posts={posts} />
      </div>
    </div>
  );
}

export default WellnessPage;